var MapcofigZWW2D = /** @class */ (function () {
    // tslint:disable-next-line:no-empty
    function MapcofigZWW2D() {
    }
    // public static jsapi = 'http://10.81.71.243:23456/hmfmstest/gisshare/A/repairemonitor/arcgis_js';
    MapcofigZWW2D.jsapi = 'http://10.81.71.243:23456/hmfmstest/gisshare/A/repairemonitor/arcgis_js';
    MapcofigZWW2D.jsapiversion4X = '4.16';
    MapcofigZWW2D.tokenserver = {
        tokenType: 'userdef',
        token_front: {
            url: 'http://10.108.3.52:8080/onemap/tokens/generateToken',
            user: 'none',
            password: 'none'
        },
        token_black: {
            url: 'http://10.108.3.16:8401/mapconfig/maptoken',
            tokenconfigname: ''
        }
    };
    MapcofigZWW2D.proxyURL = "http://www.962121.net/propertybusinessmanage/proxy.jsp";
    MapcofigZWW2D.proxyConifg = {
        useProxy: false,
        url: MapcofigZWW2D.proxyURL + '?',
        httpsDomains: [{
                proxyUrl: MapcofigZWW2D.proxyURL,
                domainName: '168.168.112.84:6080'
            }, {
                proxyUrl: MapcofigZWW2D.proxyURL,
                domainName: '168.168.112.76:6080'
            }, {
                proxyUrl: MapcofigZWW2D.proxyURL,
                domainName: '168.168.112.74:6080'
            }]
    };
    MapcofigZWW2D.fonts = {
        url: 'http://10.81.71.243:23456/hmfmstest/gisshare/A/repairemonitor/arcgis_js/4.15/fonts'
    };
    MapcofigZWW2D.gisService = {
        serverurl: 'http://10.81.71.243:23456/hmfmstest/gisshare/B/rest/services',
        baseMapServices: {
            isToken: true,
            // tokenType: 'OneMap',
            layers: [{
                    url: 'http://10.81.71.243:23456/hmfmstest/gisshare/B/rest/services/Image2019/MapServer',
                    layerEName: 'basemap_air',
                    isToken: false,
                    visible: false,
                    opacity: 1.0,
                    mapType: 'SHCTiledMapServiceLayer',
                    tag: '影像底图',
                    layerCName: '影像底图',
                    type: 'basemap_air'
                }, {
                    url: 'http://10.81.71.243:23456/hmfmstest/gisshare/B/rest/services/shmap_as3/MapServer',
                    layerEName: 'basemap_as',
                    isToken: false,
                    visible: true,
                    opacity: 1.0,
                    mapType: 'SHCTiledMapServiceLayer',
                    tag: '暗色底图',
                    layerCName: '暗色底图',
                    type: 'basemap_as'
                }, {
                    url: 'http://10.81.71.243:23456/hmfmstest/gisshare/B/rest/services/Basemap19/MapServer',
                    layerEName: 'basemap_zw',
                    isToken: false,
                    visible: false,
                    opacity: 1.0,
                    mapType: 'SHCTiledMapServiceLayer',
                    tag: '政务底图',
                    layerCName: '政务底图',
                    type: 'basemap_zw'
                }]
        },
        buildingsLayers: {
            id: "buildings_3d_layers",
            title: "空间基础",
            tag: "buildings_3d_layers",
            listMode: 'show',
            visible: true,
            layerGroups: [],
            layers: []
        },
        smapbussinessLayers: {
            serverurl: "http://10.81.71.243:23456/hmfmstest/gisshare/C/rest/services",
            istoken: true,
            tokenType: "OneMap",
            layerGroups: [{
                    id: "smap_3D_layers",
                    title: "三维业务组",
                    grouptype: '3D',
                    tag: "smap_3D_layers",
                    visible: true,
                    listMode: 'show',
                    layerGroups: [],
                    layers: []
                }, {
                    id: "smap_2D_layers",
                    title: "二维业务组",
                    grouptype: '2D',
                    tag: "smap_2D_layers",
                    visible: true,
                    listMode: 'show',
                    layerGroups: [],
                    layers: [{
                            url: 'http://10.81.71.243:23456/hmfmstest/gisshare/C/rest/services/WG_GIS_XQ_POLY/MapServer',
                            id: 'wg_gis_xq_poly',
                            isToken: true,
                            visible: true,
                            opacity: 1.0,
                            maptype: 'MapImageLayer',
                            tag: '小区面',
                            title: '小区面',
                            type: 'wg_gis_xq_poly',
                            listMode: 'show',
                            sublayers: [{
                                    id: 0,
                                    definitionExpression: "1 = 1"
                                }]
                        }, {
                            url: 'http://10.81.71.243:23456/hmfmstest/gisshare/C/rest/services/XQJKD/MapServer',
                            id: 'wg_gis_zb_jkd',
                            isToken: true,
                            visible: false,
                            opacity: 1.0,
                            maptype: 'MapImageLayer',
                            tag: '小区健康度',
                            title: '小区健康度',
                            type: 'wg_gis_zb_jkd',
                            listMode: 'show',
                            sublayers: [{
                                    id: 4,
                                    definitionExpression: "1 = 1"
                                }, {
                                    id: 3,
                                    definitionExpression: "1 = 1"
                                }, {
                                    id: 2,
                                    definitionExpression: "1 = 1"
                                }, {
                                    id: 1,
                                    definitionExpression: "1 = 1"
                                }, {
                                    id: 0,
                                    definitionExpression: "1 = 1"
                                }]
                        }, {
                            url: 'http://10.81.71.243:23456/hmfmstest/gisshare/C/rest/services/WG_GIS_FWZL/MapServer',
                            id: 'wg_gis_fwzl',
                            isToken: true,
                            visible: false,
                            opacity: 1.0,
                            maptype: 'MapImageLayer',
                            tag: '物业服务质量',
                            title: '物业服务质量',
                            type: 'wg_gis_fwzl',
                            listMode: 'show',
                            sublayers: [{
                                    id: 4,
                                    definitionExpression: "1 = 1"
                                }, {
                                    id: 3,
                                    definitionExpression: "1 = 1"
                                }, {
                                    id: 2,
                                    definitionExpression: "1 = 1"
                                }, {
                                    id: 1,
                                    definitionExpression: "1 = 1"
                                }, {
                                    id: 0,
                                    definitionExpression: "1 = 1"
                                }]
                        }, {
                            url: 'http://10.81.71.243:23456/hmfmstest/gisshare/C/rest/services/WG_ELEVATOR/MapServer',
                            id: 'wg_gis_elevator',
                            isToken: true,
                            visible: false,
                            opacity: 1.0,
                            maptype: 'MapImageLayer',
                            tag: '电梯专题图',
                            title: '电梯专题图',
                            type: 'wg_gis_elevator',
                            listMode: 'show',
                            sublayers: [{
                                    id: 4,
                                    definitionExpression: "1 = 1"
                                }, {
                                    id: 3,
                                    definitionExpression: "1 = 1"
                                }, {
                                    id: 2,
                                    definitionExpression: "1 = 1"
                                }, {
                                    id: 1,
                                    definitionExpression: "1 = 1"
                                }, {
                                    id: 0,
                                    definitionExpression: "1 = 1"
                                }]
                        }, {
                            url: 'http://10.81.71.243:23456/hmfmstest/gisshare/C/rest/services/WG_GIS_SENSOR/MapServer',
                            id: 'wg_gis_sensor',
                            isToken: true,
                            visible: false,
                            opacity: 1.0,
                            maptype: 'MapImageLayer',
                            tag: '传感器专题图',
                            title: '传感器专题图',
                            type: 'wg_gis_sensor',
                            listMode: 'show',
                            sublayers: [{
                                    id: 9,
                                    sublayers: [{
                                            id: 12,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 11,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 10,
                                            definitionExpression: "1 = 1"
                                        }]
                                }, {
                                    id: 5,
                                    sublayers: [{
                                            id: 8,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 7,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 6,
                                            definitionExpression: "1 = 1"
                                        }]
                                }, {
                                    id: 1,
                                    sublayers: [{
                                            id: 4,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 3,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 2,
                                            definitionExpression: "1 = 1"
                                        }]
                                }, {
                                    id: 0,
                                    definitionExpression: "1 = 1"
                                }]
                        }, {
                            url: 'http://10.81.71.243:23456/hmfmstest/gisshare/C/rest/services/WG_GIS_XQ_POINT/MapServer',
                            id: 'wg_gis_xq_point',
                            isToken: true,
                            visible: true,
                            opacity: 1.0,
                            maptype: 'MapImageLayer',
                            tag: '小区点',
                            title: '小区点',
                            type: 'wg_gis_xq_point',
                            listMode: 'show',
                            sublayers: [{
                                    id: 0,
                                    sublayers: [{
                                            id: 5,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 4,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 3,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 2,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 1,
                                            definitionExpression: "1 = 1"
                                        }]
                                }]
                        }, {
                            url: 'http://10.81.71.243:23456/hmfmstest/gisshare/C/rest/services/WG_GIS_MPZ/MapServer',
                            id: 'wg_gis_mpz',
                            isToken: true,
                            visible: true,
                            opacity: 1.0,
                            maptype: 'MapImageLayer',
                            tag: '门牌幢',
                            title: '门牌幢',
                            type: 'wg_gis_mpz',
                            listMode: 'show',
                            sublayers: [{
                                    id: 5,
                                    sublayers: [{
                                            id: 8,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 7,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 6,
                                            definitionExpression: "1 = 1"
                                        }]
                                }, {
                                    id: 0,
                                    sublayers: [{
                                            id: 4,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 3,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 2,
                                            definitionExpression: "1 = 1"
                                        }, {
                                            id: 1,
                                            definitionExpression: "1 = 1"
                                        }]
                                }]
                        }, {
                            id: "location_Hightlight",
                            istoken: false,
                            visible: true,
                            opacity: 1.0,
                            maptype: "GraphicsLayer",
                            tag: "地名地址高亮",
                            title: "地名地址高亮",
                            type: "image",
                            listMode: 'hide'
                        }, {
                            url: "http://10.81.71.243:23456/hmfmstest/gisshare/C/rest/services/STREET1/MapServer/0",
                            id: "jd_boundary",
                            istoken: false,
                            visible: false,
                            opacity: 0.0,
                            maptype: "FeatureLayer",
                            tag: "jd_boundary",
                            title: "上海街道边界",
                            renderer: {
                                type: "simple",
                                symbol: {
                                    type: "simple-fill",
                                    color: [0, 227, 229, 0],
                                    outline: {
                                        color: [0, 255, 0, 1],
                                        width: "2px"
                                    }
                                }
                            },
                            type: "image",
                            listMode: 'hide'
                        }, {
                            url: "http://10.81.71.243:23456/hmfmstest/gisshare/C/rest/services/DISTRICT1/MapServer/0",
                            id: "qx_boundary",
                            istoken: false,
                            visible: false,
                            opacity: 0.0,
                            maptype: "FeatureLayer",
                            tag: "qx_boundary",
                            title: "上海区县边界",
                            renderer: {
                                type: "simple",
                                symbol: {
                                    type: "simple-fill",
                                    color: [0, 227, 229, 0],
                                    outline: {
                                        color: [0, 255, 0, 1],
                                        width: "2px"
                                    }
                                }
                            },
                            type: "image",
                            listMode: 'hide'
                        }]
                }]
        }
    };
    return MapcofigZWW2D;
}());
export default MapcofigZWW2D;
